import React from 'react';
import { Typography, Tooltip } from '@material-ui/core';
import { ROW_LABEL } from './typography';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

// A setting's name, with its explanation on hover.
//
// The icon is not decoration: hover-only help is invisible until you happen to
// hover, and unreachable entirely on a touch screen. The icon advertises that
// help exists, and being focusable it also opens on keyboard focus and on tap.
const SectionHeading = ({ label, help, id, gutter = 12 }) => (
  <Typography
    {...ROW_LABEL}
    id={id}
    style={{ ...ROW_LABEL.style, marginBottom: gutter, display: 'flex', alignItems: 'center' }}
  >
    {label}
    {help ? (
      <Tooltip title={help} enterTouchDelay={0} leaveTouchDelay={6000} arrow>
        <InfoOutlinedIcon
          tabIndex={0}
          aria-label={`About ${label}`}
          fontSize="small"
          style={{ marginLeft: 6, opacity: 0.45, cursor: 'help', outlineOffset: 2 }}
        />
      </Tooltip>
    ) : undefined}
  </Typography>
);

export default SectionHeading;
